import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import axios from "axios";
import { toast } from "sonner";

const KEY = "mimes-popup-shown-v1";
const HIDDEN_ROUTES = [/^\/admin/, /^\/payment\//, /^\/cuenta\//];

export default function NewsletterPopup() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [gdprOk, setGdprOk] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (HIDDEN_ROUTES.some((r) => r.test(pathname))) return;
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 12000);
    return () => clearTimeout(t);
  }, [pathname]);

  const handleClose = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!gdprOk) { toast.error("Acepta la política de privacidad para suscribirte"); return; }
    setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter/subscribe`, { email, consent: true });
      toast.success("¡Gracias! Usa MIMES10 para tu primera compra.");
      handleClose();
    } catch { toast.error("No se pudo suscribir. Inténtalo de nuevo."); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) handleClose(); else setOpen(o); }}>
      <DialogContent data-testid="newsletter-popup" className="max-w-md bg-[color:var(--brand-bg)] border-[color:var(--brand-border)]">
        <DialogTitle className="font-serif text-3xl text-[color:var(--brand-primary)] font-light">
          10% en tu primera <span className="italic text-[color:var(--brand-terracotta)]">compra</span>
        </DialogTitle>
        <DialogDescription className="text-[color:var(--brand-neutral)]">
          Suscríbete a nuestras novedades y recibe un cupón de bienvenida.
        </DialogDescription>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <Input data-testid="popup-email" type="email" required placeholder="tu@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          <label className="flex items-start gap-2 cursor-pointer select-none">
            <input type="checkbox" data-testid="popup-gdpr" required checked={gdprOk} onChange={(e) => setGdprOk(e.target.checked)}
              className="mt-0.5 w-3.5 h-3.5 accent-[color:var(--brand-terracotta)]" />
            <span className="text-xs leading-relaxed text-[color:var(--brand-neutral)]">
              Acepto recibir novedades y la <a href="/privacidad" className="underline hover:text-[color:var(--brand-terracotta)]">política de privacidad</a>. Puedo darme de baja en cualquier momento.
            </span>
          </label>
          <Button data-testid="popup-submit" type="submit" disabled={busy} className="w-full bg-[color:var(--brand-primary)] hover:bg-black text-white rounded-md py-5">
            {busy ? "Un momento…" : "Quiero mi descuento"}
          </Button>
          <button type="button" onClick={handleClose} className="text-xs text-[color:var(--brand-neutral)]/60 hover:underline w-full text-center">No, gracias</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
